import { config } from '../constant/config'
let websocket = null
let globalCallback = null

const initWebSocket = (type, key, callback) => {
  // ws地址
  let wsUri = config.WS_URL + '/websocket/' + type + '/' + key
  websocket = new WebSocket(wsUri)
  websocket.onmessage = (e) => {
    callback(e)
  }
  websocket.onclose = (e) => {
    websocketClose(e)
  }
  websocket.onopen = () => {
    websocketOpen()
  }

  // 连接发生错误的回调方法
  websocket.onerror = () => {
    console.log('WebSocket连接发生错误')
  }
  return websocket
}

const websocketClose = (e) => {
  console.log('连接关闭：' + e.code + '，e:' + JSON.stringify(e))
}

const websocketOpen = () => {
  console.log('连接成功')
}

// 实际调用的方法
function sendSock (agentData, callback) {
  globalCallback = callback
  if (websocket.readyState === websocket.OPEN) {
    // 若是ws开启状态
    websocketSend(agentData)
  } else if (websocket.readyState === websocket.CONNECTING) {
    // 若是 正在开启状态，则等待1s后重新调用
    setTimeout(function () {
      sendSock(agentData, callback)
    }, 1000)
  } else {
    // 若未开启 ，则等待1s后重新调用
    setTimeout(function () {
      sendSock(agentData, callback)
    }, 1000)
  }
}

const websocketSend = (agentData) => {
  websocket.send(JSON.stringify(agentData))
}

// 数据接收
// eslint-disable-next-line no-unused-vars
const websocketOnmessage = (e) => {
  globalCallback(e.data)
}

export { sendSock, initWebSocket }
